"use client";

import Drawer from "@/components/drawer";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import NavigationMenuDemo from "@/components/menu";
import { buttonVariants } from "@/components/ui/button";
import Link from "next/link";
import { Icons } from "@/components/icons";
import { siteConfig } from "@/lib/config";
import { useTranslations } from "@/lib/hooks/use-translations";

export default function HeaderClient({ locale }: { locale?: 'de' | 'en' } = {}) {
  const [addBorder, setAddBorder] = useState(false);
  const { t } = useTranslations();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setAddBorder(true);
      } else {
        setAddBorder(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="hidden lg:block">
        <div className="flex items-center">
          <nav className="mr-10">
            <NavigationMenuDemo />
          </nav>

          <div className="gap-2 flex">
            <Link
              href={siteConfig.getLocalizedUrl("/contact", locale)}
              className={cn(
                buttonVariants({ variant: "default" }),
                "w-full sm:w-auto text-background flex gap-2"
              )}
            >
              <Icons.logoIcon className="h-6 w-6" />
              {t('common.buttons.getStarted')}
            </Link>
          </div>
        </div>
      </div>
      
      <div className="mt-2 cursor-pointer block lg:hidden">
        <Drawer />
      </div>

      <hr
        className={cn(
          "absolute w-full bottom-0 transition-opacity duration-300 ease-in-out right-0",
          addBorder ? "opacity-100" : "opacity-0"
        )}
      />
    </>
  );
}
